import {routeAuthentication, routeAuthenticationAdmin} from "../../base/utils";

export const accountsRoutes = [
    {
        path: '/login',
        name: 'Login',
        component: () => import('../views/Login.vue')
    },
    {
        path: '/sso-login',
        name: 'SSO Login',
        component: () => import('../views/Login.vue')
    },
    {
        path: '/forgot-password',
        name: 'Forgot Password',
        component: () => import('../views/ForgotPassword.vue')
    },
    {
        path: '/recovery',
        name: 'Reset Password',
        component: () => import('../views/ResetPassword.vue')
    },
    {
        path: '/admin/user/create',
        name: 'Create Admin User',
        component: () => import('../views/CreateAdminUser.vue')
    },
    {
        path: '/user/list',
        name: 'User List',
        component: () => import('../views/UserList.vue'),
        beforeEnter: routeAuthenticationAdmin
    },
    {
        path: '/user/edit/candidate/',
        name: 'Edit candidate',
        component: () => import('../views/UpdateCandidateUser.vue'),
        beforeEnter: routeAuthentication
    },
    {
        path: '/user/edit/:key/',
        name: 'Edit user',
        component: () => import('../views/UpdateUser.vue'),
        beforeEnter: routeAuthenticationAdmin
    },
    {
        path: '/user/create',
        name: 'Create User',
        component: () => import('../views/CreateUser.vue'),
        beforeEnter: routeAuthenticationAdmin
    },{
        path: '/user/account',
        name: 'User Account',
        component: () => import('../views/UserAccount.vue'),
        beforeEnter: routeAuthenticationAdmin
    }
];
